import './App.css';
import BranchLocator from './branchLocator.js'

function App() {
  return (
    <div className="">
    <BranchLocator/>
    </div>
  );
}

export default App;
